// --- 1. Helper: Get Variant State ---
function getVariantAvailabilityState(variant) {
  if (!variant) return null;


  const dispatchDate = window.variantMetafields?.[variant.id]?.estimated_dispatch;
  // Check for coming soon metafield
  const comingSoon = window.variantMetafields?.[variant.id]?.variant_coming_soon;
  
  const inStock = variant.inventory_quantity > 0;
  const continueSelling = variant.inventory_policy === "continue";

  if (inStock) return 1;            // In Stock
  
  // Logic for items out of stock (inventory <= 0)
  if (!continueSelling) {
    // If backorders are denied, it's either Coming Soon or Sold Out
    if (comingSoon == "true" || comingSoon === true) return 5; 
    return 2; // Sold Out
  }
  
  if (dispatchDate) return 3;       // Preorder (Out of stock + Has Date)
  return 4;                         // Backorder (Out of stock + No Date)
}

// --- 2. UI Update: Add To Cart Button ---
function updateATCButton(variant) {
  const allButtons = document.querySelectorAll("#main-atc-button, .batc_btn");
  if (allButtons.length === 0) return;

  const state = getVariantAvailabilityState(variant);

  allButtons.forEach(btn => {
    const textContainer = btn.querySelector("span") || btn;

    // Reset state
    btn.classList.remove("disabled", "preorder", "oos");
    textContainer.classList.remove("disabled", "preorder");
    btn.disabled = false;

    switch (state) {
      case 1: // In Stock
        textContainer.textContent = "Add to Cart";
        break;

      case 2: // Sold Out
        btn.disabled = true;
        btn.classList.add("disabled", "oos");
        textContainer.textContent = "Sold Out";
        break;

      case 3: // Preorder
        btn.classList.add("preorder");
        textContainer.textContent = "Pre Order";
        break;

      case 4: // Backorder
        textContainer.textContent = "Add to Cart";
        break;

      case 5: // Coming Soon
        btn.disabled = true;
        btn.classList.add("disabled");
        textContainer.textContent = "Coming Soon!";
        break;
    }
  });
}

// --- 3. UI Update: Warehouse & Christmas Block ---
function updateLeaveWarehouseBlock(variant, product) {
  const block = document.querySelector("#leave-warehouse-block");
  const christmasBlock = document.querySelector("#christmasDeliveryMesg");

  if (!block) return;

  const prefix = block.querySelector(".prefix");
  const msg = block.querySelector(".dispatchmessage");
  const beQuick = block.querySelector(".bequick-msg");
  const beQuickInline = block.querySelector(".bequick-inline-msg");

  const dispatch = window.variantMetafields?.[variant.id]?.estimated_dispatch;
  const state = getVariantAvailabilityState(variant);

  // A. Sold Out (2) or Coming Soon (5) → Hide delivery/warehouse info
  if (state === 2 || state === 5) {
    block.style.display = "none";
    if (christmasBlock) christmasBlock.style.display = "none";
    return;
  }

  block.style.display = "flex";

  // B. Be Quick tag (highest priority)
  const hasBeQuick = product?.tags?.includes("change-dispatch-quick");
  if (beQuick) beQuick.style.display = hasBeQuick ? "inline" : "none";
  if (beQuickInline) beQuickInline.style.display = hasBeQuick ? "inline" : "none";

  if (hasBeQuick) {
    if (prefix) prefix.textContent = "";
    if (msg) msg.textContent = "";
    if (christmasBlock) christmasBlock.style.display = "none";
    return;
  }

  // C. Message by availability state
  if (state === 3) {
    if (prefix) prefix.textContent = "Estimated dispatch:";
    if (msg) msg.textContent = dispatch;
  } else if (state === 1 || state === 4) {
    if (prefix) prefix.textContent = "Estimated delivery:";
    if (msg) msg.textContent = "with you in 48 hours";
  }

  // D. Christmas message logic
  if (christmasBlock) {
    const is48HourMsg = state === 1 || state === 4;

    if (is48HourMsg) {
      christmasBlock.innerHTML = "🎄 Arrives before <strong>Christmas</strong>";
      christmasBlock.style.display = "block";
    } else {
      christmasBlock.style.display = "none";
    }
  }
}

// --- 4. Main Orchestrator ---
function updateProductUI(selectedVariant) {
  const product = window.productData || window.meta?.product;
  updateATCButton(selectedVariant);
  updateLeaveWarehouseBlock(selectedVariant, product);
}

// --- 5. Load Variant by ID ---
function loadVariantById(variantId) {
  if (!variantId) return;

  const productData = window.productData || window.meta?.product;
  if (!productData) return;

  const variant = productData.variants.find(
    v => String(v.id) === String(variantId)
  );

  if (variant) {
    updateProductUI(variant);
  }
}

// --- 6. Initialization & Polling ---
document.addEventListener("DOMContentLoaded", () => {
  const productData = window.productData || window.meta?.product;
  if (!productData) return;

  const variantIdInput = document.querySelector('input[name="id"]');

  let initialId =
    variantIdInput?.value ||
    new URLSearchParams(window.location.search).get("variant");

  if (!initialId && productData.variants?.length) {
    initialId = productData.variants[0].id;
  }

  if (initialId) {
    // Small defer ensures theme JS has mounted the button
    setTimeout(() => loadVariantById(initialId), 0);
  }

  let lastProcessedVariantId = initialId;

  setInterval(() => {
    const currentInputId = variantIdInput?.value;
    const currentURLId = new URLSearchParams(window.location.search).get("variant");
    const newVariantId = currentInputId || currentURLId;

    if (newVariantId && newVariantId !== lastProcessedVariantId) {
      lastProcessedVariantId = newVariantId;
      loadVariantById(newVariantId);
    }
  }, 100);
});